export default "__VITE_ASSET__DKzV5DI7__"